import { ComponentStyleConfig } from '@chakra-ui/react';

export const Drawer: ComponentStyleConfig = {
    baseStyle: {
        closeButton: {
            borderRadius: 0
        }
    }
};
